import Box from "@pages/Article/components/ArticleParagraphElements/storyElement/box/Box";
import BoxTitle from "@pages/Article/components/ArticleParagraphElements/storyElement/box/BoxTitle";
import DataWrapper from "@pages/Article/components/ArticleParagraphElements/storyElement/DataWrapper";
import Embed from "@pages/Article/components/ArticleParagraphElements/storyElement/embed/Embed";
import Graphic from "@pages/Article/components/ArticleParagraphElements/storyElement/Graphic";
import InlineBrightcove from "@pages/Article/components/ArticleParagraphElements/storyElement/InlineBrightcove";
import InlineImage from "@pages/Article/components/ArticleParagraphElements/storyElement/InlineImage";
import InlinePodcast from "@pages/Article/components/ArticleParagraphElements/storyElement/InlinePodcast";
import InlineYoutube from "@pages/Article/components/ArticleParagraphElements/storyElement/InlineYoutube";
import ListBulleted from "@pages/Article/components/ArticleParagraphElements/storyElement/ListBulleted";
import ListNumbered from "@pages/Article/components/ArticleParagraphElements/storyElement/ListNumbered";
import ParagraphWrapper from "@pages/Article/components/ArticleParagraphElements/storyElement/ParagraphWrapper";
import PullQuote from "@pages/Article/components/ArticleParagraphElements/storyElement/PullQuote";
import Subheading from "@pages/Article/components/ArticleParagraphElements/storyElement/Subheading";
import Table from "@pages/Article/components/ArticleParagraphElements/storyElement/Table";
import { Type } from "@typings/enums";

/**
 * Factory function to create article elements based on their type.
 * This function maps different types to their corresponding React components.
 */
export const ArticleElementsFactory = (type: Type) => {
  switch (type) {
    case Type.ListBulleted:
      return ListBulleted;

    case Type.ListNumbered:
      return ListNumbered;

    case Type.SubHead:
      return Subheading;

    case Type.Paragraph:
      return ParagraphWrapper;

    case Type.Image:
      return InlineImage;

    case Type.BrightcoveVideo:
      return InlineBrightcove;

    case Type.PodcastWrapper:
    case Type.OmnyPodcast:
      return InlinePodcast;

    case Type.DataWrapper:
      return DataWrapper;

    case Type.Embed:
      return Embed;

    case Type.PullQuote:
      return PullQuote;

    case Type.Table:
      return Table;

    case Type.Graphic:
      return Graphic;

    case Type.Box:
      return Box;

    case Type.BoxTitle:
      return BoxTitle;

    case Type.YoutubeVideo:
      return InlineYoutube;
  }
};
